import { render } from "./UserInvitationOffcanvas.vue?vue&type=template&id=6e15ec20&scoped=true"
import script from "./UserInvitationOffcanvas.vue?vue&type=script&lang=js"
export * from "./UserInvitationOffcanvas.vue?vue&type=script&lang=js"

import "./UserInvitationOffcanvas.vue?vue&type=style&index=0&id=6e15ec20&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e15ec20"]])

export default __exports__